import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { saveByteArray } from "src/util/saveByteArray";
import { IDigestoReport } from "../interface/trade/IDigestoReport";
import {IDigestoContingencyBudgetRequest} from "../interface/digesto/IDigestoContingencyBudgetRequest";

enum DigestoServiceEnum {
  downloadReport = "/download-digesto-report/",
  updateReport = "/update-digesto-report-status/",
  createDigestoBudgetFromContingency = "/digesto-report-contingency/",
  orderDigestoFromContingency = "/digesto-report-contingency/",
  getContingencyDigestoReports = "/digesto-report-contingency/",
  getDigestoDiligenceByIdTrade = "/get-digesto-diligence-by-trade/"
}

export default class DigestoService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/digesto");
  }
  public updateReport = async digestoId => await this.PUT(DigestoServiceEnum.updateReport + digestoId, null, "json");

  public downloadDigestoReport = async (digestoId:number, tradeId:number = null) => {
    const data = await this.GET(DigestoServiceEnum.downloadReport + digestoId, "blob");
    saveByteArray(`relatório_digesto_${tradeId ?? digestoId}.xlsx`, data);
    return data;
  };

  public createDigestoBudgetFromContingency = async (request: IDigestoContingencyBudgetRequest): Promise<IDigestoReport> =>
    await this.POST(DigestoServiceEnum.createDigestoBudgetFromContingency, request);

  public orderDigestoReportFromContingency = async (digestoId:number): Promise<IDigestoReport> => await this.PUT(`${DigestoServiceEnum.orderDigestoFromContingency}${digestoId}`, null, "json");

  public getContingencyDigestoReports = async (): Promise<IDigestoReport[]> => await this.GET(DigestoServiceEnum.getContingencyDigestoReports);

  public getDigestoDiligenceByIdTrade = async (idTrade: number) => {
    const data = await this.GET(DigestoServiceEnum.getDigestoDiligenceByIdTrade + idTrade);
    return data;
  };
}
